import getInstance from './getInstance';
import { CustomEventTitle } from './types';

export interface Params {
  offerId?: string;
  [key: string]: unknown;
}

function logBrazeEvent(title: CustomEventTitle, params: Params) {
  try {
    const instance = getInstance();

    if (typeof instance?.logCustomEvent === 'function') {
      const isSuceess = instance.logCustomEvent<Params>(title, params);

      if (!isSuceess) {
        throw new Error(
          `failed braze logCustomEvent :>> ${JSON.stringify({
            title,
            params,
          })}`
        );
      }
    }
  } catch (e) {
    console.error('error', e);
  }
}

export default logBrazeEvent;
